import { showTrxTransactionPopup } from '@/core/presenter/controller/PopupController';
import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  trxTransaction: ViewModel.IResponseActivity;
  onClickCopyBtn?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TrxTransactionItem = ({ trxTransaction }: IProps) => {
  const handleClickTrxTransactionItem = useCallback(() => {
    showTrxTransactionPopup(trxTransaction);
  }, [trxTransaction]);

  const handleCopyClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // 이벤트 전파 방지
    e.preventDefault();
    e.stopPropagation();

    const text = trxTransaction.type === '보내기' ? trxTransaction.to : trxTransaction.from;
    navigator.clipboard.writeText(text);
  };

  const isSend = trxTransaction.type === '보내기';
  const memo = isSend ? trxTransaction.to_memo : trxTransaction.from_memo;

  return (
    <div className="activity-item" data-type={trxTransaction.type} onClick={handleClickTrxTransactionItem}>
      <p className="activity-date text-sm font-normal">{trxTransaction.date}</p>
      
      <div className="activity-row">
        <div className="activity-left">
          <div className={clsx('activity-icon-wrapper', { send: isSend, receive: !isSend })}>
            <img 
              src={`./images/${isSend ? 'send' : 'receive'}-icon.png`} 
              alt={trxTransaction.type} 
              className="activity-icon" 
            />
            <span className="activity-coin-badge text-xs font-normal">{trxTransaction.coinType}</span>
          </div>
          <div className="activity-main">
            <div className="activity-type-row">
              <span className="activity-type text-sm font-semibold">{trxTransaction.type}</span>
              <span
                className={clsx('activity-status text-sm font-medium', {
                  success: trxTransaction.status === '성공',
                  fail: trxTransaction.status === '실패',
                })}
              >
                {trxTransaction.status}
              </span>
            </div>
          </div>
        </div>
        
        <div className="activity-center">
          <div className="activity-address-row">
            <span className="text-xs font-normal">
              {isSend ? '→' : '←'} {isSend ? trxTransaction.to_short : trxTransaction.from_short}
            </span>
            <button type="button" className="copy-btn-small" onClick={handleCopyClick}>
              <img src="./images/copy-icon.png" alt="복사" className="copy-icon-small" />
            </button>
          </div>
          {memo && <p className="activity-memo text-sm font-normal">{memo}</p>}
        </div>
        
        <div className="activity-right">
          <p className="amount-value text-base font-semibold">{trxTransaction.amount}</p>
          <p className="amount-krw text-sm font-normal">{trxTransaction.krwAmount}</p>
        </div>
      </div>
    </div>
  );
};

export default TrxTransactionItem;
